module.exports = __webpack_public_path__ + "3a752dd6488644fcb8d2e01ecfb46e31.png";